import * as Yup from "yup";

// Validation schema for the login form
export const LoginSchema = Yup.object().shape({
  email: Yup.string().email("ایمیل نامعتبر است").required("ایمیل الزامی است"),
  password: Yup.string()
    .min(6, "پسورد باید حداقل 6 کاراکتر باشد")
    .required("پسورد الزامی است"),
});
